<button
    mat-icon-button
    [class.spinner]="isLoading()"
    [disabled]="isLoading()"
    [color]="buttonColor()"
    [attr.color]="buttonColor()"
    (click)="toggleFavorite()">
    <mat-icon>favorite</mat-icon>
</button>
